export const FRAUD_ROUTE_PATHS = {
  limitOperations: '/fraud/limit-operations',
  chargebacks: '/fraud/chargebacks',
  fraudOperations: '/fraud/fraud-operations',
  userFlags: '/fraud/user-flags',
  medInfractions: '/fraud/med-infractions',
};
